const BENCHMARK_GEO_LEVEL = 'benchmark_geo_level';
const RATE_BENCHMARK = 'rate_benchmark';
const MONTH = 'month';
const TTM_END_MONTH = 'ttm_end_month';
const CG_FIELDS = {
  BENCHMARK_GEO_LEVEL,
  RATE_BENCHMARK,
  MONTH,
  TTM_END_MONTH,
};

/**
 * Pivot `target` values backing the Custom Grids reports. Save As copies the
 * target verbatim, so an equality check covers a stock report and every grid
 * derived from it.
 */
const CG_TARGETS = {
  PERFORMANCE_VS_BENCHMARK: 'performance_vs_benchmark',
  BENCHMARK_TRANSACTIONAL_DETAIL: 'benchmark_transactional_detail',
};

/** Rate benchmark identifiers (`Bid`) as returned by GET /filter/benchmarks. */
const BENCHMARK_IDS = {
  STANDARD: '1',
  SPOT: '2',
  CONTRACT: '3',
  CUSTOMER_SIZE_ADJUSTED: '4',
};

export { CG_FIELDS, CG_TARGETS, BENCHMARK_IDS };
